import { SessionData } from 'owa-service/lib/types/SessionData';
import { setRTL } from '@uifabric/utilities';

/**
 * Utility to set the document direction
 * @param sessionData
 */
export function setDocumentDirection(sessionData: SessionData) {
    const { owaUserConfig } = sessionData;
    const isRTL = owaUserConfig?.SessionSettings?.IsUserCultureRightToLeft;
    document.dir = isRTL ? 'rtl' : 'ltr';
    setRTL(isRTL, true /* persistSetting */);
}
